export default __webpack_public_path__ + "static/media/img4.df236c59.jpg";